import { ApiOrgType } from 'api/org/types/ApiOrgType';
import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { useSaveListing } from 'hooks/useSaveListing';

import { StyledDropdownItem } from './ListingActionsDropdown.styled';

type Props = {
  closeMenu: () => void;
  orgId: string;
  orgName: string;
  orgType: ApiOrgType;
};

export function SaveOrgMenuItem({ closeMenu, orgId, orgName, orgType }: Props) {
  const { saved, canSave, saveListing, unsaveListing } = useSaveListing({
    listingId: orgId,
    listingType: 'ORG',
    listingName: orgName,
    orgId,
    orgType,
  });

  const saveText = getText('Save Organization');
  const unsaveText = getText('Unsave Organization');

  const onClick = (saveOrUnsaveListing: () => void) => {
    if (canSave) saveOrUnsaveListing();
    closeMenu();
  };

  return (
    <StyledDropdownItem
      onClick={() => onClick(saved ? unsaveListing : saveListing)}
      data-qa-id={`${saved ? 'unsave' : 'save'}-org`}
    >
      <Box mr="10px">
        <Icon name="star-outline" size={16} />
      </Box>

      {saved ? unsaveText : saveText}
    </StyledDropdownItem>
  );
}
